import React, { memo, useEffect,useContext } from "react";
import Header from "../Components/Header";
import PageTitleSection from "../Components/PageTitleSection";
import FooterSection from "../Components/FooterSection";
import MapContactUsSection from "../Components/MapContactUsSection";
import Spacer from "../Components/Spacer";
import BrandLogoSliderSection from "../Components/BrandLogoSliderSection";
import { getSettingValue } from "../service/userService";

const PartnerShipInquiry = () => {
    const titleWebsite = "Contact Us | Xetech";
    const descriptionWebsite = "Xetech delivers measurable business value through process automation. Let us know your technical challenges, and our experts will help you resolve them. In addition, we provide solutions for patient and clinical care, telemedicine and remote patient care,  banking, Azure, AWS, and more.";
    useEffect(() => {
        document.title = titleWebsite;
        document.getElementsByTagName("meta")[2].content = descriptionWebsite;
        document.description = descriptionWebsite;
        window.scrollTo(0, 0);
    }, [titleWebsite, descriptionWebsite]);


    return (
        <>
            <Header />
            <PageTitleSection
                title="Partnership Inquiry"
                pagetitle="Inquiry"
                bgImage="assets/images/pages/contact-us-new.jpg"
            />
            <Spacer bgClass="blackBg" />
            <section className="section blackBg">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 col-xl-4 col-12 d-flex align-item-center justify-content-center flex-column">
                            <h3>Corporate Headquarters</h3>
                            <p className="bgBlackTextWhite">
                                {getSettingValue("Address") }
                                <br />
                                <b>Phone:</b> {getSettingValue("Phone")}
                                <br />
                                <b>Fax:</b> {getSettingValue("Fax")}
                                <br />
                                <b>Email:</b>{getSettingValue("Email")}
                            </p>
                        </div>
                        <div className="col-md-8 col-xl-8 col-12">
                            <BrandLogoSliderSection
                                bgClass="blackBg"
                                bgColor="transparent"
                                title="Designing awesome brands & experiences"
                                subtitle="We are an agency located in New York. We think strategy, craft design, develop digital and create motion. To forward your brand and business."
                                urlOne="assets/images/brand-logo/trudoc.jpg"
                                altOne="Tru Doc"
                                urlTwo="assets/images/brand-logo/worldatwork.jpg"
                                altTwo="World at work"
                                urlThree="assets/images/brand-logo/icici-pru.jpg"
                                altThree="ICICI Pru"
                                urlFour="assets/images/brand-logo/fdb.jpg"
                                altFour="FDB"
                                urlFive="assets/images/brand-logo/copper-state.jpg"
                                altFive="Copper State"
                                urlSix="assets/images/brand-logo/oriel.jpg"
                                altSix="Oriel"
                                urlSeven="assets/images/brand-logo/pathway.jpg"
                                altSeven="Pathway"
                                //urlEight="assets/images/brand-logo/ssc.jpg"
                                //altEight="SSc"
                                urlEight="assets/images/brand-logo/glucare.jpg"
                                altEight="Glucare"
                                urlNine="assets/images/brand-logo/icldc.jpg"
                                altNine="ICLDC"
                                urlTen="assets/images/brand-logo/hicom.jpg"
                                altTen="HICOM"
                                urlEleven="assets/images/brand-logo/apeoplebusiness.jpg"
                                altEleven="A People Business"
                                urlTweleve="assets/images/brand-logo/compass.jpg"
                                altTweleve="Compass"
                                urlThirteen="assets/images/brand-logo/london-medical-laboratory.jpg"
                                altThirteen="London Medical Laboratory"
                                urlFourteen="assets/images/brand-logo/trailboss.jpg"
                                altFourteen="Trailboss Enterprises"
                                urlFifteen="assets/images/brand-logo/texas.jpg"
                                altFifteen="Texas Heart - Texas Heart Institute"
                            />
                        </div>
                    </div>
                </div>            </section>
            <MapContactUsSection bgClass="blackBg" />
            <Spacer bgClass="blackBg" />
            <FooterSection />
        </>
    )
}

export default memo(PartnerShipInquiry);